import NoData from "@/components/NoData";
import LtdLoading from "@/components/LichThiDauFull/LtdLoading";
import LeagueFilter from "@/components/LichThiDauByLeague/LeagueFilter";
import LeagueStandingTotal from "./LeagueStandingTotal";
import useBangXepHangByLeague from "./useBangXepHangByLeague";
import "@/components/LichThiDauFull/index.css";
import "./index.css";

/**
 * @param {object} props
 * @param {string} props.league
 */
export default function BangXepHangByLeague({ league: leagueSlug }) {
  const {
    themeStyle,
    activeSlug,
    setActiveSlug,
    league,
    standingsRes,
    waiting,
    failed,
  } = useBangXepHangByLeague(leagueSlug);

  const hasContent =
    standingsRes &&
    ((Array.isArray(standingsRes.roundScoreItems) &&
      standingsRes.roundScoreItems.length > 0) ||
      (Array.isArray(standingsRes.totalStandings) &&
        standingsRes.totalStandings.length > 0));

  return (
    <div
      className="kbv-bxh kbv-ltd-full flex flex-col gap-2 bg-[var(--theme-bg)] text-[var(--theme-text)]"
      style={themeStyle}
    >
      <div className="kbv-ltd-filter-block">
        <LeagueFilter
          selectedSlug={activeSlug}
          currentLeague={league}
          onSelect={setActiveSlug}
          themeStyle={themeStyle}
        />
      </div>
      {failed ? (
        <NoData message="Không có bảng xếp hạng" />
      ) : !activeSlug || waiting ? (
        <LtdLoading />
      ) : !hasContent ? (
        <NoData message="Không có bảng xếp hạng" />
      ) : (
        <LeagueStandingTotal
          key={league.id}
          league={league}
          standingsRes={standingsRes}
        />
      )}
    </div>
  );
}
